<template>
  <div class="image-message" :class="msg.type">
    <div class="avatar">
      <img v-if="msg.type !== 'user'" src="@/assets/images/robot.png" class="avatar-img" alt="AI" />
      <img v-else src="@/assets/images/sijiuyonghu.png" class="avatar-img" alt="User" />
    </div>
    <div class="message-body">
      <div class="sender-name" v-if="msg.type !== 'user' && msg.agentName">{{ msg.agentName }}</div>
      <div class="bubble">
        <div
          class="image-wrapper"
          :class="{ uploading: msg.uploading, failed: msg.verified === false }"
        >
          <img
            v-if="msg.images && msg.images.length && !imgLoadFailed"
            :src="msg.images[0]"
            @click="preview(msg.images[0])"
            @error="onImgError"
          />
          <div v-if="imgLoadFailed" class="img-error-placeholder">
            <van-icon name="warning-o" />
            <span>图片加载失败</span>
          </div>
          <div class="upload-mask" v-if="msg.uploading">
            <van-loading size="24px" /> 上传中
          </div>
          <div class="fail-mask" v-if="msg.verified === false">
            <van-icon name="warning-o" /> 上传失败
          </div>
          <!-- 成功/失败徽章：放在图片预览框左外侧中部（用户消息视角的左侧） -->
          <div
            v-if="msg.type === 'user' && statusBadgeClass"
            class="side-badge"
            :class="statusBadgeClass"
          >
            <van-icon :name="statusBadgeClass === 'success' ? 'passed' : 'close'" />
          </div>
        </div>
        <!-- 消息时间：放在气泡下方（用户消息显示） -->
        <div class="bubble-time" v-if="msg.time">{{ msg.time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageMessage',
  props: {
    msg: { type: Object, required: true },
    index: { type: Number, default: 0 },
  },
  data() {
    return {
      imgLoadFailed: false,
    };
  },
  watch: {
    'msg.images': {
      handler() {
        this.imgLoadFailed = false;
      },
      deep: true,
    },
  },
  computed: {
    statusBadgeClass() {
      if (!this.msg || this.msg.type !== 'user') return '';
      if (this.msg.uploading) return '';
      if (this.msg.verified === true) return 'success';
      if (this.msg.verified === false) return 'failed';
      if (this.msg.verified === 'failed') return 'failed';
      return '';
    },
  },
  methods: {
    preview(url) {
      this.$emit('preview', url);
    },
    onImgError(e) {
      console.warn('[ImageMessage] 图片加载失败:', e && e.target && e.target.src);
      this.imgLoadFailed = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  position: relative;
  width: 100%;
}
/* 用户消息：avatar 在最右（用 order 倒序），body 在中间 */
/* 系统/机器人消息：avatar 在左（默认） */
.image-message.user .avatar {
  order: 2;
  margin-left: 12px;
}
.image-message.user .message-body {
  order: 1;
  align-items: flex-end;   /* 用户消息：气泡内容靠右 */
}
.message-body {
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  min-width: 0;
  margin: 0 12px 0 0;
  align-items: flex-start;  /* 机器人/系统：整体靠左 */
}
.image-message:not(.user) .message-body {
  align-items: flex-start;
}
.image-message.user .message-body {
  align-items: flex-end;   /* 用户消息：气泡内容靠右 */
  margin-left: auto;       /* 推到右侧 */
  margin-right: 0;
}
.sender-name {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}
.bubble-time {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
  background: #e8f8ff;
}
.image-message.user .avatar {
  background: #1989fa;
}
.avatar-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.bubble {
  display: inline-block;
  max-width: 100%;
  padding: 6px;
  border-radius: 12px;
  background: #fff;
}
.image-message.user .bubble {
  background: #fff;
}
.image-wrapper {
  position: relative;
  border-radius: 8px;
  overflow: visible;
  img {
    max-width: 200px;
    max-height: 200px;
    display: block;
    border-radius: 8px;
  }
}
.image-wrapper.failed {
  border: 2px solid #ee0a24;
}
.img-error-placeholder {
  width: 60vw;
  max-width: 240px;
  min-width: 140px;
  height: auto;
  min-height: 100px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: #f7f8fa;
  color: #ee0a24;
  font-size: 14px;
  line-height: 1.4;
  box-sizing: border-box;
  text-align: center;
  border-radius: 8px;
}
.img-error-placeholder .van-icon {
  font-size: 24px;
}
.upload-mask, .fail-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  font-size: 12px;
  gap: 4px;
}
.upload-mask {
  background: rgba(0, 0, 0, 0.5);
}
.fail-mask {
  background: rgba(238, 10, 36, 0.7);
}
.status-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 6px;
}
.image-message.user .status-badge {
  margin-left: 8px;
  margin-right: 0;
}
.image-message:not(.user) .status-badge {
  margin-right: 8px;
  margin-left: 0;
}
.status-badge.success {
  background: #07c160;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.status-badge.failed {
  background: #ee0a24;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
}
.success-badge,
.fail-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.success-badge {
  background: #07c160;
}
.fail-badge {
  background: #ee0a24;
}
/* 状态徽章：放在用户消息图片预览框左侧外中部（用户视角的左侧），与图片留约 12px 间距 */
.side-badge {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(calc(-100% - 12px), -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 2;
}
.side-badge.success {
  background: #07c160;
}
.side-badge.failed {
  background: #ee0a24;
}
</style>